import * as React from 'react';
import { Select } from 'antd';

export interface ICurrencySelectProps {
  name: string;
  onChange: (e: any) => void;
  value: string | undefined;
  currencies?: Array<GQL.ICurrency>;
  style?: any;
}

export class CurrencySelect extends React.PureComponent<ICurrencySelectProps> {

  constructor(props: ICurrencySelectProps) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { value, style, currencies } = this.props;

    if (currencies) {
      return (
        <Select
          onChange={this.onChange}
          value={value}
          style={style}
        >
          {currencies.map(l => {
            return (
              <Select.Option key={l.id} value={l.id}>
                {l.value}
              </Select.Option>
            );
          })}
        </Select>
      );
    }

    return null;
  }

  private onChange(value: string) {
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: this.props.name,
          value,
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Others/CurrencySelect/CurrencySelect.tsx